export * from './testkit';
var relativePath = '/storage';
export var createUserStorageApi = function (baseUrl, http) {
    var apiUrl = baseUrl + relativePath;
    return {
        getAll: function () {
            return http.get(apiUrl + "/keys");
        },
        get: function (key) {
            return http.get(apiUrl + "/entry?key=" + key);
        },
        set: function (key, value) {
            return http.post(apiUrl + "/entry", { key: key, value: value });
        },
        setMany: function (entries) {
            return http.post(apiUrl + "/entries", { entries: entries });
        },
        delete: function (key) {
            return http.delete(apiUrl + "/entry?key=" + key);
        },
    };
};
//# sourceMappingURL=index.js.map